import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-mobile-row-field',
    templateUrl: './mobile-row-field.component.html',
    imports: [TranslateModule]
})
export class MobileRowFieldComponent {
    public label = input.required<string>();
}
